import { createApp } from 'vue'
import IkiTarihArasindakiGunSayisi from './IkiTarihArasindakiGunSayisi'
import './assets/global.css'

createApp(IkiTarihArasindakiGunSayisi).mount('#iki-tarih-arasindaki-gun-sayisi')
